module.exports = __webpack_public_path__ + "img/atlantic-country.3cb26d1a.png";